import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import colorModel from './colorModel.vue';
import { uploadFile } from '@/views/customer/applicationManage/request';
import { CONFIGURENAME } from '../../utils';
import { getQrcodeTemplate } from '@/views/insurance/releaseManage/request';
import { mapMutations } from 'vuex';
import { cryptoDecrypt } from '@/utils/aes';
export default {
  components: {
    colorModel
  },
  props: {
    configureList: {
      type: Array,
      default() {
        return [];
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    chooseStyleArr: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      form: {
        landingPageModuleDisplay: false,
        productListModule: {
          productNameColor: '#000',
          productNameFontSize: 20,
          productButtonBorderColor: '#000',
          productButtonBgColor: '#FF6B00',
          otherFieldsColor: '#989898',
          otherFieldsFontSize: 14
        },
        landingPageModule: {
          backgroundImage: '',
          buttonInfo: [{
            buttonName: '',
            buttonFontColor: '#fff',
            buttonBgColor: '#FF6B00',
            buttonJumpEvent: 'CLOSE',
            //按钮跳转事件: CLOSE关闭落地页、其它代表跳转页面
            buttonJumpEventConfig: {
              qrConfigId: '',
              //模版组ID
              customerInsuranceId: '',
              insuranceId: ''
            },
            //按钮跳转事件配置
            mark: 1,
            buttonPopUp: false,
            buttonPopUpConfig: {}
          }]
        }
      },
      colorShow: false,
      action: uploadFile,
      loading: false,
      CONFIGURENAME,
      templateList: []
    };
  },
  created() {},
  mounted() {
    this.$nextTick(async () => {
      this.form = this.styleObj;
      // 获取二维码模版列表
      this.templateList = await getQrcodeTemplate({
        customerId: ''
      });
    });
  },
  computed: {
    pageModuleShow: {
      get() {
        return this.$store.state.control.pageModuleShow;
      },
      set(val) {
        this.$store.commit('control/SET_PAGE_SHOW', val);
      }
    }
  },
  watch: {},
  methods: {
    ...mapMutations({
      SET_PAGE_SHOW: 'control/SET_PAGE_SHOW'
    }),
    changePageShowFun(val) {
      this.pageModuleShow = val;
    },
    changeFun() {
      this.$emit('itemChange', this.form);
    },
    //按钮文案去除前后空格
    handleBlurTrim(index, e) {
      this.form.landingPageModule.buttonInfo[index].buttonName = e.target.value.trim();
      this.changeFun();
    },
    imgClick(val, id) {
      console.log(val, id, '----------样式切换-------');
      this.form.controlsComponentsMark = val;
      this.form.controlsComponentsId = id;
      this.changeFun();
    },
    colorClickFun(val, key, module, index) {
      this.module = module;
      this.index = index;
      this.colorShow = true;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      if (this.module == 'landingPageModule') {
        this.form[this.module].buttonInfo[this.index][key] = val;
      } else {
        this.form[this.module][key] = val;
      }
      this.colorShow = false;
    },
    onChangePageTitle(e) {
      console.log(e, 'e');
      this.form.productListTitleDisplay = e.target.checked;
      if (!e.target.checked) {
        this.form.productListTitle = '';
      } else {
        this.form.productListTitle = '请选择投保产品';
      }
      this.changeFun();
    },
    // 落地页设置
    async onChangeLandingPage(e) {
      // 判断是否存在重复的组件
      const find = this.repeatyArr(this.chooseStyleArr);
      if (find) {
        this.$message.destroy();
        return this.$message.error(this.$t(this.CONFIGURENAME[find.controlsMark]) + this.$t('组件重复,只能存在一个'));
      }
      this.form.landingPageModuleDisplay = e.target.checked;
      this.pageModuleShow = 2;
      // 重置落地页数据
      if (e.target.checked === false) {
        this.form.landingPageModule = {
          backgroundImage: '',
          buttonInfo: [{
            buttonName: '立即投保',
            buttonFontColor: '#fff',
            buttonBgColor: '#FF6B00',
            buttonJumpEvent: 'CLOSE',
            //按钮跳转事件: CLOSE关闭落地页、其它代表跳转页面
            buttonJumpEventConfig: {},
            //按钮跳转事件配置
            mark: 1,
            buttonPopUp: false,
            buttonPopUpConfig: {}
          }]
        };
      }
    },
    // 背景图上传
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('请上传正确的图片格式,例如') + ':jpg,png,jpeg');
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error(this.$t('上传图片应小于') + '10M');
      }
      return isJpgOrPng && isLt10M;
    },
    handleChange({
      file
    }) {
      if (file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (file.status === 'done') {
        this.form.landingPageModule.backgroundImage = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        this.loading = false;
      }
    },
    // 添加按钮
    addBtnFun() {
      this.form.landingPageModule.buttonInfo.push({
        buttonName: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00',
        buttonJumpEvent: undefined,
        //按钮跳转事件: CLOSE关闭落地页、其它代表跳转页面
        buttonJumpEventConfig: {},
        //按钮跳转事件配置
        mark: 1,
        buttonPopUp: false,
        buttonPopUpConfig: {}
      });
    },
    delBtnFun(index) {
      this.form.landingPageModule.buttonInfo.splice(index, 1);
    },
    // 按钮跳转模版事件
    buttonJumpEventChange(index, e) {
      let item = this.templateList.find(item => item.id == e);
      this.form.landingPageModule.buttonInfo[index].buttonJumpEventConfig = {
        customerId: item.customerId,
        qrConfigId: item.id,
        customerInsuranceId: item.customerInsuranceId,
        insuranceId: item.insuranceId
      };
    },
    // 切换页面展示
    changePageShow(e) {
      this.changePageShowFun(e.target.value);
    },
    repeatyArr(arr) {
      let find = false;
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].controlsMark == arr[j].controlsMark) {
            find = arr[j];
            break;
          }
        }
        if (find) break;
      }
      return find;
    }
  }
};